import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Progress } from '../models/interfaces/progress.interface';

@Injectable({
  providedIn: 'root',
})
export class ProgressService {

  protected _progress: WritableSignal<Progress[]> = signal([]);

  public get progress(): Signal<Progress[]> {
    return this._progress;
  }

  public new(progress: Progress): void {
    this._progress.set([...this._progress(), progress]);
  }

  public remove(key: string): void {
    this._progress.set(
      this._progress().filter((progress) => progress.key !== key)
    );
  }

  public update(key: string, progress: Partial<Progress>): void {
    const progressValue = this._progress();

    const index = progressValue.findIndex((progress) => progress.key === key);
    progressValue[index] = { ...progressValue[index], ...progress };

    this._progress.set(progressValue);
  }

}
